<template>
  <div>
      <div class="f_mask" @click="hideBasicDataMask">
        <div class="data_set_box">
            <div class="title">板材基础设置</div>
            <div class="data_set_contnt">
                <ul>
                    <li v-for="item in dataArr" :key="item.id">
                        <div class="set_name">{{item.name}}：</div>
                        <div class="data_box">
                            <div class="clickHand" v-for="item in item.Arr" :key="item.name" @click="modify(item.id,item.name)">{{item.name}}</div>
                        </div>
                        <div class="add_box clickHand" @click="add(item.id)">添加</div>
                    </li>
                    <!--  <li>
                        <div class="color_title_box">{{colorData.name}}：</div>
                        <div class="color_box">
                                <div class="img_box clickHand" v-for="item in colorData.colorArr" :key="item.id" @click="modifyColor(item.s_color_id)">
                                    <img :src="item.color_url" alt="">
                                    <p>{{item.name}}</p>
                                </div>
                        </div>
                        <div class="add_box clickHand" @click="addColor">添加颜色</div>
                    </li> -->
                </ul>
            </div>
            <div class="data_set_bottom">
                <!-- <el-button @click="dataSet">取消</el-button>
                <el-button @click="preserveClick">保存</el-button> -->
                <div @click="dataSet">取消</div>
                <div @click="preserveClick">确认</div>
            </div>
        </div>
      </div>
      <!-- 添加保存弹框 -->
        <div class="mask" v-show="is_pop_up" @click="hideMask">
            <div class="add_pop_up">
                <div class="title">添加{{category}}</div>
                <div class="tips">请输入要添加的{{category}}</div>
                <div class="input_box"><input :type="category == '板材厚度'?'number':'text'" v-model="addData" :placeholder="'请输入 ' + category"></div>
                <div class="btn_box">
                    <div @click="cancelAdd" class="clickHand">取消</div>
                    <div @click="addPreserve" class="clickHand">确认</div>
                </div>
            </div>
        </div>
           <!-- 修改 删除弹框 -->
        <div class="mask" v-show="is_modify_pop_up" @click="hideMask">
            <div class="modify_pop_up">
            <!-- <div class="modify_pop_up_top">
                <div class="title">编辑{{category}}</div>
                <div class="tips">请输入要修改的{{category}}</div>
                <div class="input_box"><input type="text" v-model="modifyData"></div>
                <div @click="modifyPreserve" class="clickHand">确定</div>
            </div>
            <div @click="deletePreserve" class="delete_box clickHand">删除此项</div> -->
                <div class="title">编辑{{category}}</div>
                <div class="tips">请输入要修改的{{category}}</div>
                <div class="input_box"><input :type="category == '板材厚度'?'number':'text'" v-model="modifyData"></div>
                <div class="btn_box">
                    <div @click="deletePreserve" class="delete_box clickHand">删除此项</div>
                    <div@click="modifyPreserve" class="clickHand">保存</div>
                </div>
            </div>
        </div>
          <!-- 获取色卡弹框 -->
          <!-- <div class="mask" v-show="boxShow" @click="hideMask">
              <ColorBox @chooseColor="chooseColor"></ColorBox>
          </div> -->
          <!-- 修改色卡弹框 -->
          <!-- <div class="mask" v-show="colorCard" @click="hideMask">
              <div class="color_card_pop_up">
                  <div class="color_card_box"><img :src="imgUrl" alt=""></div>
                  <div>色卡名：<input type="text" v-model="colorCardName"></div>
                  <div class="color_card_bottom">
                      <div @click="preservecolor" class="clickHand">保存</div>
                      <div @click="deleteColor" class="clickHand">删除色卡</div>
                  </div>
              </div>
          </div> -->
    </div>
</template>

<script>
import ColorBox from './ChoiceColorBox'
import { mapMutations, mapState } from 'vuex'

export default {
		components:{
            ColorBox
		},
		props:[],
		data() {
			return {
                dataArr:[
                     {
                    id:0,
                    name:'基材',
                    Arr: [],
                    obj:{
                        id:0,
                        Arr:[]
                    }
                },{
                    id:2,
                    name:'表面纹理(钢板)',
                    Arr:[],
                    obj:{
                        id:2,
                        Arr:[]
                    }
                },{//板材厚度修改回来
                    id:3,
                    name:'板材厚度',
                    Arr:[],
                    obj:{
                        id:3,
                        Arr:[]
                    }
                },{
                    id:4,
                    name:'贴面工艺',
                    Arr:[],
                    obj:{
                        id:4,
                        Arr:[]
                    }
                },{
                    id:5,
                    name:'品牌',
                    Arr:[],
                    obj:{
                        id:5,
                        Arr:[]
                    }
                },{
                    id:6,
                    name:'规格',
                    Arr:[],
                    obj:{
                        id:6,
                        Arr:[]
                    }
                },{
                    id:7,
                    name:'分类',
                    Arr:[],
                    obj:{
                        id:7,
                        Arr:[]
                    }
                }
                ],//列表数据
                colorData:{
                     id:1,
                    name:'颜色',
                    colorArr: []
                },//颜色
                is_pop_up: false,//添加弹框
                is_modify_pop_up:false,//修改 删除弹框
                isDelete: false,//删除弹框
                colorDelete:false,//色卡删除弹框
                boxShow:false,//色卡弹框
                colorCard:false,//修改 色卡弹框
                colorId:-1,//色卡id
                colorCardName: '',
                imgUrl:'',
                category: '',
                addData:'',//添加商品数据
                modifyData:'',//修改数据
                modifyIndex:-1,//修改索引
                id:-1,//板材数据类别id
                colorList:[],//选中色卡数组

                //-----------------------------------
               /*  obj: {}, */
			}
		},
		computed: {
            ...mapState({
                userData: 'supplierInfo',
                userInfo: 'userInfo'
            }),
            supplier_id(){
              if(this.$store.state.supplierInfo){
                return this.$store.state.supplierInfo.id
              }else{
                return 0
              }
            },
		},
		mounted() {
            // this.axios({
            //     method:'GET',
            //     url:'https://ggtools.thinkerx.com/erp/get_supplier_setting',
            //     params:{
            //         uid:this.userInfo.id,
            //         supplier_id: this.supplier_id,
            //         setting_type: 'plank_setting'
            //     }
            // }).then(res => {
            //     console.log('获取商品基础数据',res.data)
            //     let data = res.data.data
            //     let newArr = []
            //     console.log('修改前的基础数据数组',data)
            //     for(let i in data){
            //         if(i === 'bspec'){
            //             // console.log('要修改的',data[i])
            //             for(let j in data[i]){
            //                 // console.log(data[i][j])
            //                 data[i][j] = {
            //                     id:0,
            //                     name: data[i][j]
            //                 }
            //             }
            //         }
            //         if(i === 'cratf'){
            //             // console.log('要修改的',dataModify[i])
            //             for(let j in data[i]){
            //                 // console.log(data[i][j])
            //                 data[i][j] = {
            //                     id:4,
            //                     name: data[i][j]
            //                 }
            //             }
            //         }
            //          if(i === 'spec'){
            //             // console.log('要修改的',dataModify[i])
            //             for(let j in data[i]){
            //                 // console.log(data[i][j])
            //                 data[i][j] = {
            //                     id:6,
            //                     name: data[i][j]
            //                 }
            //             }
            //         }
            //         if(i === 'texture'){
            //             // console.log('要修改的',dataModify[i])
            //             for(let j in data[i]){
            //                 // console.log(data[i][j])
            //                 data[i][j] = {
            //                     id:2,
            //                     name: data[i][j]
            //                 }
            //             }
            //         }
            //         if(i === 'brand'){
            //             // console.log('要修改的',dataModify[i])
            //             for(let j in data[i]){
            //                 // console.log(data[i][j])
            //                 data[i][j] = {
            //                     id:5,
            //                     name: data[i][j]
            //                 }
            //             }
            //         }
            //         if(i === 'thick'){
            //             // console.log('要修改的',dataModify[i])
            //             for(let j in data[i]){
            //                 // console.log(data[i][j])
            //                 data[i][j] = {
            //                     id:3,
            //                     name: data[i][j]
            //                 }
            //             }
            //         }
            //         if(i === 'part_type'){
            //             // console.log('要修改的',dataModify[i])
            //             for(let j in data[i]){
            //                 // console.log(data[i][j])
            //                 data[i][j] = {
            //                     id:7,
            //                     name: data[i][j]
            //                 }
            //             }
            //         }
                    
            //     }
            //     console.log('修改返回基础数据数组格式',data)
                
            //     // let data = res.data.data
            //     let dataArr = this.dataArr
            //     for(let i in dataArr){
            //         if(dataArr[i].id == 0){
            //             // setting_data.bspec = dataArr[i].Arr
            //             dataArr[i].Arr = data.bspec||[]
                        
            //             // dataArr[i].obj.Arr = data.bspec||[]
            //         }
            //         if(dataArr[i].id == 2){
            //             // setting_data.texture = dataArr[i].Arr
            //              dataArr[i].Arr = data.texture||[]
            //             //  dataArr[i].obj.Arr = data.texture||[]
            //         }
            //         if(dataArr[i].id == 4){
            //             // setting_data.cratf = dataArr[i].Arr
            //              dataArr[i].Arr = data.cratf||[]
            //             //  dataArr[i].obj.Arr = data.cratf||[]
            //         }
            //         if(dataArr[i].id == 5){
            //             dataArr[i].Arr = data.brand||[]
            //             // dataArr[i].obj.Arr = data.brand||[]
            //         }
            //         if(dataArr[i].id == 6){
            //             // setting_data.spec = dataArr[i].Arr
            //              dataArr[i].Arr = data.spec||[]
            //             //  dataArr[i].obj.Arr = data.brand||[]
            //         }
            //         if(dataArr[i].id == 3){
            //             // setting_data.spec = dataArr[i].Arr
            //              dataArr[i].Arr = data.thick||[]
            //             //  dataArr[i].obj.Arr = data.brand||[]
            //         }
            //         if(dataArr[i].id == 7){
            //             // setting_data.spec = dataArr[i].Arr
            //              dataArr[i].Arr = data.part_type||[]
            //             //  dataArr[i].obj.Arr = data.brand||[]
            //         }
            //     }
            // })
            this.$get("/py/erp/get_supplier_setting",{
                uid:this.userInfo.id,
                supplier_id: this.supplier_id,
                setting_type: 'plank_setting'
            },res => {  
                let data = res.data
                let newArr = []
                console.log('修改前的基础数据数组',data)
                for(let i in data){
                    if(i === 'bspec'){
                        // console.log('要修改的',data[i])
                        for(let j in data[i]){
                            // console.log(data[i][j])
                            data[i][j] = {
                                id:0,
                                name: data[i][j]
                            }
                        }
                    }
                    if(i === 'cratf'){
                        // console.log('要修改的',dataModify[i])
                        for(let j in data[i]){
                            // console.log(data[i][j])
                            data[i][j] = {
                                id:4,
                                name: data[i][j]
                            }
                        }
                    }
                     if(i === 'spec'){
                        // console.log('要修改的',dataModify[i])
                        for(let j in data[i]){
                            // console.log(data[i][j])
                            data[i][j] = {
                                id:6,
                                name: data[i][j]
                            }
                        }
                    }
                    if(i === 'texture'){
                        // console.log('要修改的',dataModify[i])
                        for(let j in data[i]){
                            // console.log(data[i][j])
                            data[i][j] = {
                                id:2,
                                name: data[i][j]
                            }
                        }
                    }
                    if(i === 'brand'){
                        // console.log('要修改的',dataModify[i])
                        for(let j in data[i]){
                            // console.log(data[i][j])
                            data[i][j] = {
                                id:5,
                                name: data[i][j]
                            }
                        }
                    }
                    if(i === 'thick'){
                        // console.log('要修改的',dataModify[i])
                        for(let j in data[i]){
                            // console.log(data[i][j])
                            data[i][j] = {
                                id:3,
                                name: data[i][j]
                            }
                        }
                    }
                    if(i === 'part_type'){
                        // console.log('要修改的',dataModify[i])
                        for(let j in data[i]){
                            // console.log(data[i][j])
                            data[i][j] = {
                                id:7,
                                name: data[i][j]
                            }
                        }
                    }
                    
                }
                console.log('修改返回基础数据数组格式',data)
                
                // let data = res.data.data
                let dataArr = this.dataArr
                for(let i in dataArr){
                    if(dataArr[i].id == 0){
                        // setting_data.bspec = dataArr[i].Arr
                        dataArr[i].Arr = data.bspec||[]
                        
                        // dataArr[i].obj.Arr = data.bspec||[]
                    }
                    if(dataArr[i].id == 2){
                        // setting_data.texture = dataArr[i].Arr
                         dataArr[i].Arr = data.texture||[]
                        //  dataArr[i].obj.Arr = data.texture||[]
                    }
                    if(dataArr[i].id == 4){
                        // setting_data.cratf = dataArr[i].Arr
                         dataArr[i].Arr = data.cratf||[]
                        //  dataArr[i].obj.Arr = data.cratf||[]
                    }
                    if(dataArr[i].id == 5){
                        dataArr[i].Arr = data.brand||[]
                        // dataArr[i].obj.Arr = data.brand||[]
                    }
                    if(dataArr[i].id == 6){
                        // setting_data.spec = dataArr[i].Arr
                         dataArr[i].Arr = data.spec||[]
                        //  dataArr[i].obj.Arr = data.brand||[]
                    }
                    if(dataArr[i].id == 3){
                        // setting_data.spec = dataArr[i].Arr
                         dataArr[i].Arr = data.thick||[]
                        //  dataArr[i].obj.Arr = data.brand||[]
                    }
                    if(dataArr[i].id == 7){
                        // setting_data.spec = dataArr[i].Arr
                         dataArr[i].Arr = data.part_type||[]
                        //  dataArr[i].obj.Arr = data.brand||[]
                    }
                }
            })
            //获取供应商保存的色卡
            // this.axios({
            //     method: 'GET',
            //     url: 'https://ggtools.thinkerx.com/erp/get_supplier_color',
            //     params: {
            //         uid:this.userInfo.id,
            //         supplier_id: this.supplier_id,
            //     }
            // }).then(res => {
            //     // console.log('获取供应商保存的色卡',res.data)
            //     this.colorData.colorArr= res.data.data.res
            // })
            this.$get("/py/erp/get_supplier_color",{
                uid:this.userInfo.id,
                supplier_id: this.supplier_id,
            },res => {  
                this.colorData.colorArr= res.data.res
            })
            var data = [
                {
                    id:0,
                    name:'基材',
                    Arr: []
                },{
                    id:2,
                    name:'表面纹理(钢板)',
                    Arr:[]
                },{
                    id:3,
                    name:'板材厚度',
                    Arr:[]
                },{
                    id:4,
                    name:'贴面工艺',
                    Arr:[]
                },{
                    id:5,
                    name:'品牌',
                    Arr:[]
                },{
                    id:6,
                    name:'规格',
                    Arr:[]
                },{
                    id:7,
                    name:'分类',
                    Arr: []
                }
            ]
            var colorData = {
                    id:1,
                    name:'颜色',
                    colorArr: []
                }
		},
		methods: {
             dataSet(){
                this.$emit('dataSet',false)
            },
           //-------------------保存 基材、纹理、贴面、规格、色卡---------------------
            preserveClick(){
                 let setting_data = {
                    bspec: [],//基材 0
                    texture: [],//纹理 2
                    cratf: [],//贴面 4
                    spec: [],//规格 6
                    thick: [],//厚度 3
                    part_type: [],//分类
                }
                let dataArr = this.dataArr
                for(let i in dataArr){
                    if(dataArr[i].id == 0){
                        for(let j in dataArr[i].Arr){
                            setting_data.bspec.push(dataArr[i].Arr[j].name)
                            // setting_data.bspec.push(dataArr[i].obj.Arr[j])
                        }
                    }
                    if(dataArr[i].id == 2){
                         for(let j in dataArr[i].Arr){
                            setting_data.texture.push(dataArr[i].Arr[j].name)
                            // setting_data.texture.push(dataArr[i].obj.Arr[j])
                        }
                    }
                    if(dataArr[i].id == 4){
                         for(let j in dataArr[i].Arr){
                            setting_data.cratf.push(dataArr[i].Arr[j].name)
                            // setting_data.cratf.push(dataArr[i].obj.Arr[j])
                        }
                    }
                    if(dataArr[i].id == 6){
                         for(let j in dataArr[i].Arr){
                            setting_data.spec.push(dataArr[i].Arr[j].name)
                            // setting_data.spec.push(dataArr[i].obj.Arr[j])
                        }
                    }
                    if(dataArr[i].id == 3){
                         for(let j in dataArr[i].Arr){
                            setting_data.thick.push(dataArr[i].Arr[j].name)
                            // setting_data.thick.push(dataArr[i].obj.Arr[j])
                        }
                    }
                    if(dataArr[i].id == 7){
                         for(let j in dataArr[i].Arr){
                            setting_data.part_type.push(dataArr[i].Arr[j].name)
                            // setting_data.part_type.push(dataArr[i].obj.Arr[j])
                        }
                    }
                }
                //  console.log('传递基础数据数组',setting_data)
                // this.axios({
                //     method:'POST',
                //     url:'https://ggtools.thinkerx.com/erp/set_supplier_setting',
                //     data:{
                //         uid:this.userInfo.id,
                //         supplier_id: this.supplier_id,
                //         setting_type: 'plank_setting',
                //         setting_data: setting_data
                //     }
                //     }).then(res => {
                //             // console.log('设置商品基础数据返回结果',res.data)
                //             if(res.data.status == 1){
                //                 this.$message.success('保存成功')
                //             }
                //     })
                    this.$post("/py/erp/set_supplier_setting",{
                        uid:this.userInfo.id,
                        supplier_id: this.supplier_id,
                        setting_type: 'plank_setting',
                        setting_data: setting_data
                    },res => {
                        if(res.status == 1){
                            this.$message.success('保存成功')
                            this.$emit('dataSet',false)
                        }
                    })
                    //-------------------保存选中色卡---------------
                    /* let data = []
                    let colorList = this.colorList
                    for(let i in colorList){
                        let obj = {}
                        obj.name = colorList[i].name
                        obj.id = colorList[i].id
                        data.push(obj)
                    }
                    //  console.log('传递色卡数据数组',data)
                   if(data.length != 0){
                        this.axios({
                        method: 'POST',
                        url: 'https://ggtools.thinkerx.com/erp/supplier_save_color',
                        data: {
                            uid:this.userInfo.id,
                            supplier_id: this.supplier_id,
                            data: data
                        }
                    }).then(res => {
                        console.log(res.data)
                    })
                   } */
                
            },
            hideBasicDataMask(){
                let event1 = event.currentTarget;
                let event2 = event.target
                if(event1 == event2){
                    this.$emit('dataSet',false)//基础数据设置弹框
                }
            },
            hideMask(event){
                this.addData = ''
                let event1 = event.currentTarget;
                let event2 = event.target
                if(event1 == event2){
                    this.is_pop_up = false//添加弹框
                    this.is_modify_pop_up = false//修改弹框
                    this.isDelete = false//删除确认弹框
                    this.colorDelete = false//颜色卡删除确认弹框
                    this.colorCard = false//色卡修改弹框
                    this.boxShow = false//色卡弹框
                }
            },
            cancelAdd(){
                this.is_pop_up = false//添加弹框
                this.addData = ''
            },
            //-------------------添加--------------------------
            add(id){
                this.category = ''
                this.is_pop_up = true
                this.id = id
                let dataArr = this.dataArr
                for(let i in dataArr){
                    if(id == dataArr[i].id){
                        this.category = dataArr[i].name
                    }
                }
            },
            addPreserve(){
                let dataArr = this.dataArr
                let id = this.id
                let addData = this.addData
                let a =0
                let arr = []
                if(addData == ''){
                     this.$message.warning('添加输入内容不能为空');
                }else{
                    for(let i in dataArr){
                        if(id == dataArr[i].id && id != 5){
                            if(dataArr[i].Arr.length == 0){
                                let obj  = {}
                                obj.id = id
                                obj.name = addData
                                dataArr[i].Arr.push(obj)
                            }else{
                                // dataArr[i].Arr.push(addData)
                                let obj  = {}
                                obj.id = id
                                obj.name = addData

                                let b = 0
                                // dataArr[i].Arr.push(obj)


                                for(let j in dataArr[i].Arr){
                                    //添加去重
                                    /* if(arr.indexOf(dataArr[i].Arr[j]) === -1){
                                        arr.push(dataArr[i].Arr[j])
                                    } */
                                    // console.log('///',dataArr[i].Arr[j].name)
                                    if(dataArr[i].Arr[j].name == addData){
                                        b = 1
                                    }
                                }
                                if(b == 0){
                                    dataArr[i].Arr.push(obj)
                                }else{
                                    this.$message('请勿重复添加')
                                }
                               /*  for(let j in dataArr[i].obj.Arr){
                                    if(arr2.indexOf(dataArr[i].obj.Arr[j]) === -1){
                                        arr2.push(dataArr[i].obj.Arr[j])
                                    }
                                } */
                                // dataArr[i].Arr = arr
                                // dataArr[i].obj.Arr = arr
                            }
                        }
                    }
                    // console.log('*************',dataArr)
                    this.addData = ''
                    if(id == 5){//----------------添加品牌-------------------------
                        this.$post("/py/erp/set_supplier_brand",{
                            uid:this.userInfo.id,
                            supplier_id: this.supplier_id,
                            name: addData,
                        },res => {  
                            if(res.status == 1){
                                this.$message.success('添加成功')
                                for(let i in dataArr){
                                    if(id == dataArr[i].id){
                                        a = 1
                                        let obj  = {}
                                        obj.id = id
                                        obj.name = addData
                                        dataArr[i].Arr.push(obj)
                                        // dataArr[i].obj.Arr.push(addData)
                                    }
                                }
                            }else{
                                if(a != 1){
                                    this.$message.error('添加失败，品牌名已被使用');
                                }
                                return
                            }
                        })
                    }
                }
                 this.is_pop_up = false
            },
            modify(id,name){
                // console.log('修改的数据',id,name)
                this.is_modify_pop_up = true
                let dataArr = this.dataArr
                for(let i in dataArr){
                  /*  for(let j in dataArr[i].Arr){
                       if(id == dataArr[i].Arr[j].id){
                        //    console.log(dataArr[i].id)
                           this.id = dataArr[i].id
                           this.modifyIndex = j
                           this.category = dataArr[i].name
                           this.modifyData = name
                       }
                   } */
                   if(dataArr[i].id == id){
                       this.id = dataArr[i].id
                       this.category = dataArr[i].name
                       this.modifyData = name
                       for(let j in dataArr[i].Arr){
                           if(dataArr[i].Arr[j].name == name){
                               this.modifyIndex = j
                           }
                       }
                   }
                }
                // console.log('55555555555555555555',this.category,this.modifyIndex)

            },
            modifyPreserve(){
                let modifyData = this.modifyData
                let org_name = ''
                // console.log(modifyData,this.id,this.modifyIndex)
                let dataArr = this.dataArr
                let id = this.id
                let index = this.modifyIndex
                let arr = []
               /*  let length = -1 */
                for(let i in dataArr){
                    if(id == dataArr[i].id){
                        org_name = dataArr[i].Arr[index].name
                        /* length = dataArr[i].Arr.length */
                        // console.log('修改的数据',modifyData,'修改的数组',dataArr[i].Arr,'数组长度', length)
                        let b = 0
                        for(let j in dataArr[i].Arr){

                            /* if(modifyData != dataArr[i].Arr[j] && j == dataArr[i].Arr.length-1 && id != 5){
                                console.log('进来了')
                                dataArr[i].Arr[index].name = modifyData
                            } */
                            if(dataArr[i].Arr[j].name == modifyData && id != 5){
                                b=1
                            }
                        }
                        if(b ==0 && id != 5){
                            dataArr[i].Arr[index].name = modifyData
                        }else if(id != 5){
                            this.$message('修改数据请勿重复')
                        }
                       

                    }
                }
                 if(id == 5){//----------------修改品牌-------------------------
                    // console.log('修改品牌',modifyData)
                    // console.log('原品牌名',org_name)
                    // this.axios({
                    //     method: 'POST',
                    //     url: 'https://ggtools.thinkerx.com/erp/set_supplier_brand',
                    //     data: {
                    //         uid:this.userInfo.id,
                    //         supplier_id: this.supplier_id,
                    //         name: modifyData,
                    //         org_name: org_name
                    //     }
                    // }).then(res => {
                    //     // console.log(res.data)
                    //     if(res.data.status == 1){
                    //         this.$message.success('修改成功')
                    //         for(let i in dataArr){
                    //             if(id == dataArr[i].id){
                    //                 let obj = {
                    //                     id:id,
                    //                     name:modifyData
                    //                 }
                    //                 dataArr[i].Arr.splice(index,1,obj)
                    //             }
                    //         }
                    //     }
                    //     if(res.data.status == 0){
                    //          this.$message.error('修改失败，品牌名已被使用');
                    //     }
                    // })
                    this.$post("/py/erp/set_supplier_brand",{
                        uid:this.userInfo.id,
                        supplier_id: this.supplier_id,
                        name: modifyData,
                        org_name: org_name
                    },res => {
                        if(res.status == 1){
                            this.$message.success('修改成功')
                            for(let i in dataArr){
                                if(id == dataArr[i].id){
                                    let obj = {
                                        id:id,
                                        name:modifyData
                                    }
                                    dataArr[i].Arr.splice(index,1,obj)
                                }
                            }
                        }
                        if(res.status == 0){
                             this.$message.error('修改失败，品牌名已被使用');
                        }
                    })
                }
                this.is_modify_pop_up = false
            },


            deletePreserve(){//删除
                this.$confirm('此操作为永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
                }).then(() => {
                    let dataArr = this.dataArr
                    let id = this.id
                    let index = this.modifyIndex
                    let deleteName = ''
                    for(let i in dataArr){
                        if(id == dataArr[i].id){
                            deleteName = dataArr[i].Arr[index].name
                            dataArr[i].Arr.splice(index,1)
                        }
                    }
                    if(id == 5){//----------------删除品牌-------------------------
                        // console.log('删除品牌',deleteName)
                        // console.log(typeof deleteName)
                        // this.axios({
                        //     method: 'POST',
                        //     url: 'https://ggtools.thinkerx.com/erp/delete_supplier_brand',
                        //     data: {
                        //         uid:this.userInfo.id,
                        //         supplier_id: this.supplier_id,
                        //         name: deleteName,
                        //     }
                        // }).then(res => {
                        //     // console.log(res.data)
                        //     if(res.data.status == 1){
                        //             this.$message.success('删除成功')
                        //         }
                        // })
                        this.$post("/py/erp/delete_supplier_brand",{
                            uid:this.userInfo.id,
                            supplier_id: this.supplier_id,
                            name: deleteName,
                        },res => {
                            if(res.status == 1){
                                this.$message.success('删除成功')
                            }
                        })
                    }
                    this.is_modify_pop_up = false
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

             //---------------添加色卡---------------------------
            addColor(){
                this.boxShow = !this.boxShow
            },
            chooseColor(colorList){//-----------选中色卡--------------
            // console.log('选中的色卡',colorList)
                this.boxShow = !this.boxShow
                this.colorList = colorList
                if(Array.isArray(colorList)){
                   let colorArr = this.colorData.colorArr
                    if(colorList.length==0){
                        this.$message.warning('未添加色卡');
                    }else{
                        // console.log('已有的色卡1',this.colorData.colorArr)
                        // console.log('选中的色卡1',colorList)
                        let a = 0
                        colorList.forEach(item => {
                            a = 1
                            colorArr.push(item)
                        })
                        let arr = []
                        for(let i in colorArr){
                            if(arr.indexOf(colorArr[i]) === -1){
                                arr.push(colorArr[i])
                            }
                        }
                        // console.log('去重后的数组',arr)
                        this.colorData.colorArr = arr
                        if(a==1){
                            // console.log('添加完后的',this.colorData.colorArr)
                            this.$message.success('添加成功')
                        }
                    }
                }
            },
            modifyColor(id){
                // console.log(id)
                this.colorCard = true
                let colorArr = this.colorData.colorArr
                this.colorId = id
                // console.log(colorArr)
                for(let i in colorArr){
                    if(this.colorId == colorArr[i].s_color_id){
                        this.imgUrl = colorArr[i].color_url
                        this.colorCardName = colorArr[i].name
                    }
                }

            },
            preservecolor(){
                // console.log(this.colorCardName)
                let colorCardName = this.colorCardName
                let colorArr = this.colorData.colorArr
                for(let i in colorArr){
                     if(this.colorId == colorArr[i].s_color_id){
                        colorArr[i].name = colorCardName
                    }
                }
               /*  console.log('色卡id',this.colorId)
                console.log('色卡name',colorCardName) */
                // console.log('已选颜色对象数组',this.colorData)
                let id = this.colorId
                let name = colorCardName
                // this.axios({//----------修改色卡---------------
                //     method: 'POST',
                //      url: 'https://ggtools.thinkerx.com/erp/supplier_update_color',
                //      data: {
                //         uid:this.userInfo.id,
                //         supplier_id:this.supplier_id,
                //         id:id,
                //         name:name
                //      }
                // }).then(res => {
                //     // console.log(res.data)
                //     if(res.data.status == 1){
                //          this.$message.success('修改成功')
                //      }else{
                //          this.$message.error('修改失败')
                //      }
                // })
                this.$post("/py/erp/supplier_update_color",{
                    uid:this.userInfo.id,
                    supplier_id:this.supplier_id,
                    id:id,
                    name:name
                },res => {
                    if(res.status == 1){
                         this.$message.success('修改成功')
                     }else{
                         this.$message.error('修改失败')
                     }
                })

                this.colorCard = false
            },
            deleteColor(){
                this.$confirm('此操作将永久删除该色卡, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
                }).then(() => {
                    let colorArr = this.colorData.colorArr
                    for(let i in colorArr){
                        if(this.colorId == colorArr[i].s_color_id){
                            colorArr.splice(i,1)
                        }
                    }
                    // this.axios({//----------删除色卡---------------
                    //     method: 'POST',
                    //     url: 'https://ggtools.thinkerx.com/erp/supplier_delete_color',
                    //     data: {
                    //         uid:this.userInfo.id,
                    //         supplier_id: this.supplier_id,
                    //         color_id:this.colorId
                    //     }
                    // }).then(res => {
                    //     //  console.log(res.data)
                    //     if(res.data.status == 1){
                    //         this.$message.success('删除成功')
                    //     }
                    // })
                    this.$post("/py/erp/supplier_delete_color",{
                        uid:this.userInfo.id,
                        supplier_id: this.supplier_id,
                        color_id:this.colorId
                    },res => {
                        if(res.status == 1){
                            this.$message.success('删除成功')
                        }
                    })
                    this.colorCard = false
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
                });
            }
		}
	}
</script>

<style lang="less">

 .f_mask{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(51, 51, 51, 0.5);
        z-index: 1;
    }
    .mask{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        background-color: rgba(51, 51, 51, 0.5);
            .clickHand{
                cursor: pointer;
            }
            .add_pop_up{
                width: 420px;
                height: 220px;
                border-radius: 8px;
                margin: 0 auto;
                padding: 20px 40px;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                background-color: rgba(255, 255, 255, 1);
                div{
                    text-align: left;
                }
                .title{
                    font-size: 16px;
                    color: rgba(51, 51, 51, 1);
                }
                .tips{
                    margin-top: 24px;
                    margin-bottom: 12px;
                    font-size: 14px;
                    color: rgba(112, 112, 112, 1);
                }
                .input_box{
                    width: 340px;
                    height: 30px;
                    input{
                        width: 100%;
                        height: 100%;
                        border-radius: 4px;
                        padding: 5px 0 5px 8px;
                        outline: none;
                        border: 1px solid rgba(183, 183, 183, 1);
                    }
                }
                .btn_box{
                    margin-top: 40px;
                    display: flex;
                    justify-content: flex-end;
                    div{
                        width: 80px;
                        font-size: 14px;
                        height: 32px;
                        line-height: 32px;
                        cursor: pointer;
                        text-align: center;
                    }
                    div:nth-child(1){
                        color: rgba(51, 51, 51, 1);
                    }
                    div:nth-child(2){
                        color: rgba(255, 255, 255, 1);
                        background: linear-gradient(131deg, #87B3FF 0%, #6376F7 100%);
                        opacity: 1;
                        border-radius: 6px;
                    }
                }
                
            }
            .modify_pop_up{
                /* width: 300px;
                height: 80px;
                 border-radius: 10px;
                margin: 0 auto;
                padding: 20px 10px;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                background-color: white;
                    >.modify_pop_up_top{
                        display: flex;
                        justify-content: space-between;
                            input{
                                width: 100px;
                            }
                    }
                    >.delete_box{
                            margin-top: 10px;
                            font-style: 12px;
                            color: blue;
                            text-align: left;
                    } */
                width: 420px;
                height: 220px;
                border-radius: 8px;
                margin: 0 auto;
                padding: 20px 40px;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                background-color: rgba(255, 255, 255, 1);
                div{
                    text-align: left;
                }
                .title{
                    font-size: 16px;
                    color: rgba(51, 51, 51, 1);
                }
                .tips{
                    margin-top: 24px;
                    margin-bottom: 12px;
                    font-size: 14px;
                    color: rgba(112, 112, 112, 1);
                }
                .input_box{
                    width: 340px;
                    height: 30px;
                    input{
                        width: 100%;
                        height: 100%;
                        border-radius: 4px;
                        padding: 5px 0 5px 8px;
                        outline: none;
                        border: 1px solid rgba(183, 183, 183, 1);
                    }
                }
                .btn_box{
                    margin-top: 40px;
                    display: flex;
                    justify-content: flex-end;
                    div{
                        width: 80px;
                        font-size: 14px;
                        height: 32px;
                        line-height: 32px;
                        cursor: pointer;
                        text-align: center;
                    }
                    div:nth-child(1){
                        color: rgba(251, 60, 60, 1);
                    }
                    div:nth-child(2){
                        color: rgba(255, 255, 255, 1);
                        background: linear-gradient(131deg, #87B3FF 0%, #6376F7 100%);
                        opacity: 1;
                        border-radius: 6px;
                    }
                }
            }
            .delete_pop_up{
                width: 300px;
                height: 80px;
                 border-radius: 10px;
                margin: 0 auto;
                padding: 20px 30px;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                background-color: white;
                .isDelete{
                    display: flex;
                    justify-content: space-between;
                    div{
                        border: 1px solid #666666;
                    }
                }

            }
            .color_card_pop_up{
                width: 300px;
                height:200px;
                border-radius: 10px;
                margin: 0 auto;
                padding: 20px 30px;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                background-color: white;
                >.color_card_box{
                    margin-bottom: 40px;
                   img{
                        width: 40px;
                        height: 40px;
                   }
                }
                >.color_card_bottom{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 40px;
                    >div{
                        border: 1px solid #666666;
                    }
                }
            }
            .color_delete_pop_up{
                 width: 300px;
                height: 80px;
                 border-radius: 10px;
                margin: 0 auto;
                padding: 20px 30px;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                background-color: white;
                 .isDeleteColor{
                    display: flex;
                    justify-content: space-between;
                    div{
                        border: 1px solid #666666;
                    }
                }
            }
    }
.data_set_box{
    .clickHand{
        cursor: pointer;
    }
    
    /* border: 1px solid red; */
    width:860px;
   /*  height:1000px; */
    margin:10px auto 0;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    padding: 20px 40px;
    border-radius: 10px;
    background-color: white;
    .title{
        font-size: 13px;
        color: rgba(153, 153, 153, 1);
        text-align: left;
    }
    .data_set_contnt{
        ul{
            li{
                display: flex;
                justify-content:space-between;
                margin: 20px 0;
            /*  border: 1px solid red; */
                .set_name{
                    font-size: 14px;
                    color: rgba(51, 51, 51, 1);
                    width: 120px;
                    text-align: left;
                     padding: 15px 0;
                }
                .data_box{
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    width: 600px;
                    >div{
                        margin: 10px;
                        border: 1px solid rgba(200, 200, 200, 1);
                        background: rgba(242, 242, 242, 1);
                        padding: 5px 9px;
                        border-radius: 8px;
                        font-size: 14px;
                    }
                }
                .add_box{
                    padding: 15px 9px;
                    color: rgba(99, 118, 247, 1);
                    font-size: 14px;
                }
                >.color_title_box{
                    width: 50px;
                }
                >.color_box{
                    display: flex;
                    justify-self: flex-start;
                    overflow-x: auto;
                    width: 600px;
                    >.img_box{
                        margin-left: 10px;
                        >img{
                            width: 40px;
                            height: 40px;
                        }
                        >p{
                            font-size: 12px;
                        }
                    }
                }
                
            }
        }
    }
    
    .data_set_bottom{
        display: flex;
        justify-content: flex-end;
        >div{
            width: 80px;
            font-size: 14px;
            height: 32px;
            line-height: 32px;
            cursor: pointer;
            text-align: center;
        }
        >div:nth-child(1){
            color: rgba(51, 51, 51, 1);
        }
        >div:nth-child(2){
            color: rgba(255, 255, 255, 1);
            background: linear-gradient(131deg, #87B3FF 0%, #6376F7 100%);
            opacity: 1;
            border-radius: 6px;
        }

    }
}


</style>
